import { render, staticRenderFns } from "./YourResourcesIcon.vue?vue&type=template&id=9e030f42"
import script from "./YourResourcesIcon.vue?vue&type=script&lang=js"
export * from "./YourResourcesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports